import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
const blogPosts = [{
  id: 1,
  title: 'Top 5 Signature Cocktails for Summer Weddings',
  content: `
      <p>Summer weddings are all about vibrant colors, refreshing flavors, and unforgettable moments. As the sun sets and the celebration begins, nothing sets the tone quite like a perfectly crafted signature cocktail.</p>
      
      <h3>1. The Botanical Bliss</h3>
      <p>A sophisticated blend of premium gin, elderflower liqueur, fresh cucumber, and a hint of mint. It's light, crisp, and incredibly refreshing for those warm afternoon ceremonies.</p>
      
      <h3>2. Magenta Sunset Margarita</h3>
      <p>Our take on the classic, featuring hibiscus-infused tequila, fresh lime juice, and a touch of agave. The striking magenta hue perfectly matches our brand and adds a pop of color to your wedding photos.</p>
      
      <h3>3. Sparkling Peach & Thyme Fizz</h3>
      <p>For those who love a bit of sparkle, this cocktail combines chilled Prosecco with white peach purée and a sprig of fresh thyme for an aromatic finish.</p>
      
      <h3>4. Spiced Pineapple Punch</h3>
      <p>A tropical delight with a kick. Dark rum, fresh pineapple juice, lime, and a house-made spiced syrup. It's a crowd-pleaser that brings the vacation vibes to your venue.</p>
      
      <h3>5. Lavender Lemonade Collins</h3>
      <p>Elegant and floral. Vodka, fresh-squeezed lemonade, and a delicate lavender syrup. Garnish with a lemon wheel and a sprig of dried lavender for that premium look.</p>
      
      <p>At Sips & Nibblez, we work closely with couples to customize these recipes, ensuring every sip reflects their personal style and the unique atmosphere of their special day.</p>
    `,
  category: 'Weddings',
  date: 'June 12, 2026',
  image: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&q=80&w=1200',
  author: 'Zobug',
  readTime: '5 min read'
}, {
  id: 2,
  title: 'The Art of the Perfect Mocktail: Sophistication Without the Spirits',
  content: `
      <p>The modern guest expects more than just soda or juice when they choose not to drink alcohol. At Sips & Nibblez, we treat mocktails with the same reverence as our alcoholic counterparts.</p>
      
      <h3>Beyond the "Virgin" Drink</h3>
      <p>We avoid the term "virgin" because it often implies something is missing. Instead, we focus on "Botanical Blends" and "Signature Mocktails" that are complete, complex, and sophisticated in their own right.</p>
      
      <h3>Complexity is Key</h3>
      <p>The challenge with mocktails is replacing the "bite" and complexity that alcohol provides. We achieve this through:</p>
      <ul>
        <li><strong>House-made Syrups:</strong> Infusing simple syrups with peppercorns, ginger, or herbs.</li>
        <li><strong>Shrubs:</strong> Using vinegar-based fruit syrups to add acidity and depth.</li>
        <li><strong>Premium Tonics:</strong> Selecting high-quality mixers that provide bitterness and carbonation.</li>
      </ul>
      
      <p>Whether you're hosting a dry wedding or simply want to provide inclusive options for all guests, our mocktail program ensures no one feels like an afterthought.</p>
    `,
  category: 'Mixology',
  date: 'May 28, 2026',
  image: 'https://cdn.magicpatterns.com/uploads/hDZQatreQxFVWfc1uwrHoh/Image_(49).jpg',
  author: 'Zobug',
  readTime: '4 min read'
}, {
  id: 3,
  title: 'Elevating Corporate Events with a Custom Mobile Bar',
  content: `
      <p>Corporate events are often the backbone of professional networking. Moving beyond the standard "open bar" can significantly impact the energy and success of your gathering.</p>
      
      <h3>Brand Integration</h3>
      <p>A custom mobile bar isn't just about serving drinks; it's a branding opportunity. We can create cocktails that match your company colors or name drinks after your latest products or core values.</p>
      
      <h3>Interactive Networking</h3>
      <p>A live mixology station acts as a natural icebreaker. Watching a professional craft a beautiful drink provides a shared experience for guests, sparking conversation and easing the transition from "work mode" to "networking mode."</p>
      
      <h3>Professionalism and Flair</h3>
      <p>Our master mixologists bring a level of professionalism that reflects your brand's standards. We handle the logistics, the setup, and the service, allowing you to focus on your clients and colleagues.</p>
    `,
  category: 'Corporate',
  date: 'May 15, 2026',
  image: 'https://cdn.magicpatterns.com/uploads/5yN64wqTPGjWVnhgLzAFWw/Image_(55).jpg',
  author: 'Zobug',
  readTime: '6 min read'
}, {
  id: 4,
  title: 'Pairing Gourmet Desserts with Signature Sips',
  content: `
      <p>The finale of an event is often the most remembered. Pairing our gourmet bites and desserts with the right signature sips creates a harmonious sensory experience.</p>
      
      <h3>The Science of Pairing</h3>
      <p>We look for two things when pairing: Complement or Contrast. A rich chocolate shooter might be complemented by an espresso martini, or contrasted by a bright, acidic berry-based cocktail.</p>
      
      <h3>Our Favorite Pairings</h3>
      <ul>
        <li><strong>Mini Fruit Tarts + Elderflower Spritz:</strong> The light floral notes of the drink elevate the fresh fruit flavors.</li>
        <li><strong>Dark Chocolate Cake Pops + Spiced Rum Old Fashioned:</strong> The warmth of the spices cuts through the richness of the chocolate.</li>
        <li><strong>Lemon Curd Shooters + Gin & Basil Smash:</strong> A double hit of citrus and herb that cleanses the palate.</li>
      </ul>
      
      <p>When you book Sips & Nibblez, we don't just provide food and drink; we provide a curated menu where every element works together.</p>
    `,
  category: 'Pairings',
  date: 'April 30, 2026',
  image: 'https://cdn.magicpatterns.com/uploads/wVm7kHz2wF77pb8aL32vqL/Image_(46).jpg',
  author: 'Zobug',
  readTime: '5 min read'
}];
export function BlogDetails() {
  const {
    id
  } = useParams();
  const post = blogPosts.find(p => p.id === Number(id));
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  if (!post) {
    return <div className="min-h-screen bg-black text-white flex items-center justify-center" data-id="element-245">
        <div className="text-center" data-id="element-246">
          <h1 className="text-4xl font-bold mb-4" data-id="element-247">Post Not Found</h1>
          <Link to="/blog" className="text-[#992f74] hover:underline" data-id="element-248">
            Back to Blog
          </Link>
        </div>
      </div>;
  }
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-[#050505] selection:bg-[#992f74] selection:text-white font-montserrat flex flex-col" data-id="element-249">
      <Header data-id="element-250" />

      <main className="flex-grow pt-20" data-id="element-251">
        {/* Hero Image Section */}
        <div className="relative h-[60vh] w-full overflow-hidden" data-id="element-252">
          <div className="absolute inset-0 bg-black/40 z-10" data-id="element-253"></div>
          <motion.img initial={{
          scale: 1.1
        }} animate={{
          scale: 1
        }} transition={{
          duration: 1.5
        }} src={post.image} alt={post.title} className="w-full h-full object-cover" data-id="element-254" />
          <div className="absolute inset-0 z-20 flex items-end" data-id="element-255">
            <div className="max-w-4xl mx-auto px-6 pb-12 w-full" data-id="element-256">
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.3,
              duration: 0.8
            }} data-id="element-257">
                <div className="flex items-center gap-4 mb-4" data-id="element-258">
                  <span className="bg-[#992f74] text-white text-[10px] font-bold tracking-widest uppercase px-3 py-1 rounded-full" data-id="element-259">
                    {post.category}
                  </span>
                  <span className="text-white/80 text-xs tracking-wider" data-id="element-260">
                    {post.date}
                  </span>
                </div>
                <h1 className="text-4xl md:text-6xl font-montserrat font-black italic text-white leading-tight drop-shadow-2xl" data-id="element-261">
                  {post.title}
                </h1>
              </motion.div>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <article className="max-w-4xl mx-auto px-6 py-16 md:py-24" data-id="element-262">
          <div className="flex flex-col md:flex-row gap-12" data-id="element-263">
            {/* Sidebar Info */}
            <div className="md:w-1/4 order-2 md:order-1" data-id="element-264">
              <div className="sticky top-32 space-y-8 border-l border-white/10 pl-8" data-id="element-265">
                <div data-id="element-266">
                  <h4 className="text-[#992f74] text-[10px] font-bold tracking-widest uppercase mb-2" data-id="element-267">
                    Written By
                  </h4>
                  <p className="text-white font-medium" data-id="element-268">{post.author}</p>
                </div>
                <div data-id="element-269">
                  <h4 className="text-[#992f74] text-[10px] font-bold tracking-widest uppercase mb-2" data-id="element-270">
                    Read Time
                  </h4>
                  <p className="text-white font-medium" data-id="element-271">{post.readTime}</p>
                </div>
                <div data-id="element-272">
                  <h4 className="text-[#992f74] text-[10px] font-bold tracking-widest uppercase mb-2" data-id="element-273">
                    Share
                  </h4>
                  <div className="flex gap-4 mt-2" data-id="element-274">
                    <button className="text-white/40 hover:text-[#992f74] transition-colors text-xs uppercase tracking-widest" data-id="element-275">
                      FB
                    </button>
                    <button className="text-white/40 hover:text-[#992f74] transition-colors text-xs uppercase tracking-widest" data-id="element-276">
                      IG
                    </button>
                    <button className="text-white/40 hover:text-[#992f74] transition-colors text-xs uppercase tracking-widest" data-id="element-277">
                      TW
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Text */}
            <div className="md:w-3/4 order-1 md:order-2" data-id="element-278">
              <div className="prose prose-invert prose-magenta max-w-none text-white/70 leading-relaxed space-y-6 text-lg font-light" dangerouslySetInnerHTML={{
              __html: post.content
            }} data-id="element-279" />

              <div className="mt-16 pt-8 border-t border-white/10" data-id="element-280">
                <Link to="/blog" className="inline-flex items-center text-[#992f74] font-bold tracking-widest uppercase text-sm hover:text-white transition-colors group" data-id="element-281">
                  <span className="mr-2 transform group-hover:-translate-x-1 transition-transform" data-id="element-282">
                    ←
                  </span>{' '}
                  Back to The Pour
                </Link>
              </div>
            </div>
          </div>
        </article>

        {/* Related Posts Placeholder */}
        <section className="bg-[#0A0A0A] py-20 px-6 border-t border-white/5" data-id="element-283">
          <div className="max-w-7xl mx-auto" data-id="element-284">
            <h2 className="text-3xl font-montserrat font-black italic text-white mb-12 uppercase tracking-tight" data-id="element-285">
              Keep <span className="text-[#992f74]" data-id="element-286">Reading</span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-287">
              {blogPosts.filter(p => p.id !== post.id).slice(0, 2).map(related => <Link key={related.id} to={`/blog/${related.id}`} className="group block" data-id="element-288">
                    <div className="relative aspect-video overflow-hidden rounded-xl mb-4" data-id="element-289">
                      <img src={related.image} alt={related.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-290" />
                      <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors" data-id="element-291"></div>
                    </div>
                    <h3 className="text-xl font-bold text-white group-hover:text-[#992f74] transition-colors" data-id="element-292">
                      {related.title}
                    </h3>
                  </Link>)}
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-293" />
    </motion.div>;
}